import { Dropdown } from "@nova/component-dropdown"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    selectActiveSearchPanelPlugin,
    selectProjectFilter,
    setActiveSearchPanelPlugin,
    setProjectFilter,
} from "../slice"
import { getProjectFilterOptionById, projectFilterOptions } from "./projectFilterOptions"
import { useState } from "react"
import { ExpandableContent } from "@nova/component-expandable-content"
import classNames from "classnames"
import { useGeolocatedProjects } from "features/map/layers/geolocated-project/useGeolocatedProjects"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export const OverviewProjectFilter = () => {
    const dispatch = useAppDispatch()
    const projectFilterId = useAppSelector(selectProjectFilter)
    const projectFilter = getProjectFilterOptionById(projectFilterId)
    const [hovering, setHovering] = useState(false)
    const active = useAppSelector(selectActiveSearchPanelPlugin) === "projects"
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const {
        data: { geolocatedProjects },
    } = useGeolocatedProjects({ orgId })
    return (
        <div
            className={classNames(
                "flex items-center gap-2 rounded-full pl-3 pr-2 h-8 shadow-sm pointer-events-auto cursor-pointer transition-colors",
                {
                    "bg-black-600": !active && !hovering,
                    "bg-black-900": !active && hovering,
                    "bg-blue-500": active,
                }
            )}
            onClick={() => dispatch(setActiveSearchPanelPlugin(active ? undefined : "projects"))}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
        >
            <div
                className={classNames("telegraf transition-colors", {
                    "text-gray-100": !active && !hovering,
                    "text-white": !active && hovering,
                    "text-gray-900": active,
                })}
            >
                Projects
            </div>
            <ExpandableContent isOpen={hovering && !active} direction="width">
                <div className="flex items-center gap-2 h-full">
                    <div
                        className={classNames("w-px h-4 transition-colors", {
                            "bg-white-100": !active,
                            "bg-black-100": active,
                        })}
                    />
                    <Dropdown stopPropagation>
                        <Dropdown.Trigger className="h-full shrink-0">
                            <div className="h-full flex items-center group">
                                <div
                                    className={classNames("shrink-0 transition-colors", {
                                        "text-gray-300 group-hover:text-gray-100": !active,
                                        "text-gray-700 group-hover:text-gray-900": active,
                                    })}
                                >
                                    {projectFilter.shortTitle}
                                </div>
                                <Icons.SmallIcon
                                    Icon={Icons.ArrowDropdown}
                                    className={classNames("transition-colors", {
                                        "text-gray-300 group-hover:text-gray-100": !active,
                                        "text-gray-700 group-hover:text-gray-900": active,
                                    })}
                                />
                            </div>
                        </Dropdown.Trigger>
                        <Dropdown.Menu replaceTrigger className="-translate-x-1.5 -translate-y-1.5">
                            <div className="py-1 bg-gray-700 flex flex-col w-[150px]">
                                <small className="pl-11 py-1 text-gray-300">Active in</small>
                                {projectFilterOptions.map((option) => {
                                    return (
                                        <Dropdown.ButtonItem
                                            key={option.id}
                                            onClick={() => dispatch(setProjectFilter(option.id))}
                                        >
                                            <div className="flex items-center h-7 py-1 cursor-pointer">
                                                <div className="w-11 shrink-0 flex justify-center items-center">
                                                    {option.id === projectFilterId && (
                                                        <Icons.SmallIcon
                                                            Icon={Icons.Checkmark}
                                                            className="text-green-500"
                                                        />
                                                    )}
                                                </div>
                                                <small className="text-white">{option.title}</small>
                                            </div>
                                        </Dropdown.ButtonItem>
                                    )
                                })}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div
                        className={classNames("w-px h-4 transition-colors", {
                            "bg-white-100": !active,
                            "bg-black-100": active,
                        })}
                    />
                </div>
            </ExpandableContent>
            <div className="py-1.5 h-full">
                <div
                    className={classNames(
                        "leading-none px-2 flex justify-center items-center rounded-full h-full min-w-[30px] shrink-0 font-mono text-xs transition-colors",
                        {
                            "bg-white-100 text-gray-300": !active,
                            "bg-black-200 text-gray-700": active,
                        }
                    )}
                >
                    {geolocatedProjects.length}
                </div>
            </div>
        </div>
    )
}
